export const defaultLabels = [
  {
    id: 1,
    value: 'style',
    label: 'Style & Tendances',
    description: 'Dernières tendances et conseils de style'
  },
  {
    id: 2,
    value: 'soins',
    label: 'Soins & Techniques',
    description: 'Conseils et techniques de soins capillaires'
  },
  {
    id: 3,
    value: 'bien-etre',
    label: 'Bien-être',
    description: 'Conseils bien-être et soins naturels'
  },
  {
    id: 4,
    value: 'produits',
    label: 'Produits',
    description: 'Guides et conseils sur les produits'
  },
  {
    id: 5,
    value: 'conseils',
    label: 'Conseils Pro',
    description: 'Conseils professionnels et expertise'
  }
]; 